import { $core } from '../../../../CORE/src/front/$core'

/**
 * データリスト一覧からバージョン指定でインポートモーダルを開く
 * @param recordId
 */
export const openKickMasterDataImportWithVersionModal = async (recordId) => {
  const record = await $core.$models.yhc_masters.findById(recordId)
  if (!record) {
    $core.$toast.error('データが見つかりません')
    return
  }
  const version = record.version
  $core.$modals.openModal({
    component: 'KickMasterDataImportWithVersionButton',
    componentProps: {
      version,
      record,
    },
    modalProps: {
      title: 'マスタデータ取込実行',
    },
  })
}
